export interface SearchEntry {
  title: string;
  description: string;
  href: string;
  product: string;
  section: string;
}

export const searchIndex: SearchEntry[] = [
  // Flows — Overview
  {
    title: "Introduction",
    description: "What Anter Flows is and how to get started",
    href: "/docs/flows",
    product: "flows",
    section: "Overview",
  },
  {
    title: "Quickstart",
    description: "Create and run your first agent workflow in minutes",
    href: "/docs/flows/quickstart",
    product: "flows",
    section: "Overview",
  },
  {
    title: "Key concepts",
    description: "Agents, graphs, nodes, connections, and how they fit together",
    href: "/docs/flows/concepts",
    product: "flows",
    section: "Overview",
  },
  // Flows — Build
  {
    title: "Your agents",
    description: "Create, configure, and manage agents in your project",
    href: "/docs/flows/agents",
    product: "flows",
    section: "Build",
  },
  {
    title: "The agent graph",
    description: "Visual editor for designing multi-agent workflows",
    href: "/docs/flows/graph",
    product: "flows",
    section: "Build",
  },
  {
    title: "Agent settings",
    description: "Model selection, system prompts, temperature, and output format",
    href: "/docs/flows/agent-settings",
    product: "flows",
    section: "Build",
  },
  {
    title: "Sub-agents",
    description: "Delegate work to specialist agents within a workflow",
    href: "/docs/flows/sub-agents",
    product: "flows",
    section: "Build",
  },
  {
    title: "Connections",
    description: "Wire transfer and delegation edges between agents",
    href: "/docs/flows/connections",
    product: "flows",
    section: "Build",
  },
  // Flows — Extend
  {
    title: "Skills",
    description: "Add reusable domain knowledge and instructions to agents",
    href: "/docs/flows/skills",
    product: "flows",
    section: "Extend",
  },
  {
    title: "Tools",
    description: "Give agents the ability to take actions and call external services",
    href: "/docs/flows/tools",
    product: "flows",
    section: "Extend",
  },
  {
    title: "MCP servers",
    description: "Connect Model Context Protocol servers as tool providers",
    href: "/docs/flows/mcp-servers",
    product: "flows",
    section: "Extend",
  },
  // Flows — Run
  {
    title: "Playground",
    description: "Test your agents interactively before deploying",
    href: "/docs/flows/playground",
    product: "flows",
    section: "Run",
  },
  {
    title: "Schedules",
    description: "Run agents automatically on a cron schedule",
    href: "/docs/flows/schedules",
    product: "flows",
    section: "Run",
  },
  {
    title: "Call the API",
    description: "Trigger agent runs programmatically from your application",
    href: "/docs/flows/call-api",
    product: "flows",
    section: "Run",
  },
  {
    title: "A2A",
    description: "Agent-to-agent communication across organizations",
    href: "/docs/flows/a2a",
    product: "flows",
    section: "Run",
  },
  // Flows — Operate
  {
    title: "Versions",
    description: "Draft, promote, and roll back agent versions",
    href: "/docs/flows/versions",
    product: "flows",
    section: "Operate",
  },
  {
    title: "Executions",
    description: "View run history, routing timelines, and debug traces",
    href: "/docs/flows/executions",
    product: "flows",
    section: "Operate",
  },
  {
    title: "Usage analytics",
    description: "Token consumption and run counts over time",
    href: "/docs/flows/usage",
    product: "flows",
    section: "Operate",
  },

  // Admin — Overview
  {
    title: "Introduction",
    description: "Overview of all admin modules and first-time setup",
    href: "/docs/admin",
    product: "admin",
    section: "Overview",
  },
  {
    title: "Dashboard",
    description: "Organization-wide metrics and model provider status",
    href: "/docs/admin/dashboard",
    product: "admin",
    section: "Overview",
  },
  // Admin — Agent Builder
  {
    title: "Agent Builder overview",
    description: "Read-only topology registry and MCP tool viewer for platform staff",
    href: "/docs/admin/agent-builder",
    product: "admin",
    section: "Agent Builder",
  },
  // Admin — Integrations
  {
    title: "Integrations",
    description:
      "Channel connectors — Slack, WhatsApp, Telegram — and already-connected MCP status",
    href: "/docs/admin/integrations",
    product: "admin",
    section: "Integrations",
  },
  {
    title: "Connecting services",
    description: "Set up Slack, WhatsApp, and Telegram channel connectors",
    href: "/docs/admin/connecting-services",
    product: "admin",
    section: "Integrations",
  },
  {
    title: "OAuth connections",
    description: "Browser OAuth, stored tokens, and domain-wide delegation",
    href: "/docs/admin/oauth",
    product: "admin",
    section: "Integrations",
  },
  // Admin — Knowledge Base
  {
    title: "Knowledge Base",
    description: "Org-level file store for agent reference documents",
    href: "/docs/admin/knowledge-base",
    product: "admin",
    section: "Knowledge Base",
  },
  {
    title: "Managing files",
    description: "Upload, import URLs, assign to projects, tag, and delete",
    href: "/docs/admin/managing-files",
    product: "admin",
    section: "Knowledge Base",
  },
  // Admin — Organization
  {
    title: "Team",
    description: "Invite users and manage owner, admin, and member roles",
    href: "/docs/admin/team",
    product: "admin",
    section: "Organization",
  },
  {
    title: "Settings",
    description: "Organization name, slug, ID, and your current account status",
    href: "/docs/admin/settings",
    product: "admin",
    section: "Organization",
  },

  // Chat — Overview
  {
    title: "Introduction",
    description: "Two chat modes — Agent chat and Meta-Agent",
    href: "/docs/chat",
    product: "chat",
    section: "Overview",
  },
  {
    title: "Quickstart",
    description: "Send your first message and build your first agent",
    href: "/docs/chat/quickstart",
    product: "chat",
    section: "Overview",
  },
  {
    title: "Key concepts",
    description: "Sessions, selector bar, artifact panel, and permissions",
    href: "/docs/chat/concepts",
    product: "chat",
    section: "Overview",
  },
  // Chat — Talk to your agents
  {
    title: "Selecting an agent",
    description: "Project and agent dropdowns, session restore, and status badges",
    href: "/docs/chat/selecting-agent",
    product: "chat",
    section: "Talk to your agents",
  },
  {
    title: "Chat sessions",
    description: "Session history, titles, agent scoping, and session management",
    href: "/docs/chat/sessions",
    product: "chat",
    section: "Talk to your agents",
  },
  // Chat — Meta-Agent
  {
    title: "Meet the Meta-Agent",
    description: "What it is, how to enter and exit, and when to use it",
    href: "/docs/chat/meta-agent",
    product: "chat",
    section: "Meta-Agent",
  },
  {
    title: "Build an agent",
    description: "Full creation flow from description to live agent",
    href: "/docs/chat/build-agent",
    product: "chat",
    section: "Meta-Agent",
  },
  {
    title: "Refine an agent",
    description: "Continue building, version mode, and promotion controls",
    href: "/docs/chat/refine-agent",
    product: "chat",
    section: "Meta-Agent",
  },
  // Chat — Features
  {
    title: "Slash commands",
    description: "/agent and /meta commands and the command palette",
    href: "/docs/chat/slash-commands",
    product: "chat",
    section: "Features",
  },
  {
    title: "File uploads",
    description: "Attach files to messages when the agent supports it",
    href: "/docs/chat/file-uploads",
    product: "chat",
    section: "Features",
  },
  // MCP Server — Overview
  {
    title: "Introduction",
    description: "Anter is itself an MCP server — connect any MCP-compatible client",
    href: "/docs/mcp-server",
    product: "mcp-server",
    section: "Overview",
  },
  {
    title: "Quickstart",
    description: "Connect Claude Code, Claude Desktop, or OpenCode in a few minutes",
    href: "/docs/mcp-server/quickstart",
    product: "mcp-server",
    section: "Overview",
  },
  {
    title: "Key concepts",
    description: "Authentication, transports, sessions, and organization scoping",
    href: "/docs/mcp-server/concepts",
    product: "mcp-server",
    section: "Overview",
  },
  // MCP Server — Tools
  {
    title: "Agent lifecycle",
    description: "Design, create, revise, and inspect agents through MCP tool calls",
    href: "/docs/mcp-server/agent-lifecycle",
    product: "mcp-server",
    section: "Tools",
  },
  {
    title: "Running & observability",
    description: "Trigger a run and read back its history and routing trace",
    href: "/docs/mcp-server/execution",
    product: "mcp-server",
    section: "Tools",
  },
  {
    title: "Projects & LLM providers",
    description: "List projects and manage model providers through MCP",
    href: "/docs/mcp-server/providers",
    product: "mcp-server",
    section: "Tools",
  },
  {
    title: "MCP server management",
    description: "List, add, update, or test the MCP servers connected to your projects",
    href: "/docs/mcp-server/servers",
    product: "mcp-server",
    section: "Tools",
  },
  {
    title: "Skills & toolsets",
    description: "Browse your skill catalog and Anter's builtin toolset catalog",
    href: "/docs/mcp-server/skills-tools",
    product: "mcp-server",
    section: "Tools",
  },
  {
    title: "Utility tools",
    description: "One-off LLM calls, file analysis, and knowledge base search",
    href: "/docs/mcp-server/utility",
    product: "mcp-server",
    section: "Tools",
  },

  // Runtime — Overview
  {
    title: "Introduction",
    description: "What the Agent Runtime is and who it's for",
    href: "/docs/runtime",
    product: "runtime",
    section: "Overview",
  },
  {
    title: "How a run executes",
    description: "How a multi-agent run actually executes, turn by turn",
    href: "/docs/runtime/execution-model",
    product: "runtime",
    section: "Overview",
  },

  // Runtime — Orchestration
  {
    title: "Transfer vs. delegate",
    description: "The two distinct ways one sub-agent hands work to another",
    href: "/docs/runtime/transfer-vs-delegate",
    product: "runtime",
    section: "Orchestration",
  },
  {
    title: "Designing a routing graph",
    description: "Typical shapes, reachability, and avoiding full transfer meshes",
    href: "/docs/runtime/routing-graph-design",
    product: "runtime",
    section: "Orchestration",
  },
  {
    title: "Correction nudges",
    description: "Why you'll sometimes see a system correction block instead of a hard failure",
    href: "/docs/runtime/correction-nudges",
    product: "runtime",
    section: "Orchestration",
  },

  // Runtime — Limits & Reliability
  {
    title: "Limits and budgets",
    description: "The caps that shape how far a run can go",
    href: "/docs/runtime/limits-and-budgets",
    product: "runtime",
    section: "Limits & Reliability",
  },
  {
    title: "Reading the routing timeline",
    description: "Glossary of routing events for diagnosing runs",
    href: "/docs/runtime/routing-timeline",
    product: "runtime",
    section: "Limits & Reliability",
  },

  // Runtime — Trust & Continuity
  {
    title: "Permissions and approvals",
    description: "How tool call approvals and fail-closed behaviors work",
    href: "/docs/runtime/permissions",
    product: "runtime",
    section: "Trust & Continuity",
  },
  {
    title: "Memory and conversation boundaries",
    description: "What actually gets remembered between conversation turns, and what doesn't",
    href: "/docs/runtime/memory",
    product: "runtime",
    section: "Trust & Continuity",
  },
  {
    title: "Resuming and streaming",
    description: "How an interrupted run can (or can't) be picked back up",
    href: "/docs/runtime/resume-streaming",
    product: "runtime",
    section: "Trust & Continuity",
  },

  // Runtime — Cross-Agent
  {
    title: "Agent-to-agent dispatch",
    description: "Dispatching work to external agents, cycle detection, and limits",
    href: "/docs/runtime/agent-to-agent",
    product: "runtime",
    section: "Cross-Agent",
  },
];
